import { Box, Typography, useTheme } from "@mui/material";

import React, { useEffect, useRef } from "react";

import SaleSvg from "@/assets/svgs/sale.svg?react";
import { HeapService } from "@/services/heap";
import { useMonitoringRetention } from "@/hooks/legalProceedings/useMonitoringRetention";

/**
 * Dormant banner shown when the plan is expired/inactive: monitoring is paused,
 * new movements stop, but the history stays available. Mirrors RestorePlanBanner.
 */
export const MonitoringPausedBanner = () => {
  const theme = useTheme();
  const { isMonitoringPaused, monitoredCount } = useMonitoringRetention();

  const visible = isMonitoringPaused && monitoredCount > 0;
  const impressionTracked = useRef(false);
  useEffect(() => {
    if (visible && !impressionTracked.current) {
      impressionTracked.current = true;
      HeapService.track("Monitoramento Pausado Exibido", { monitoredCount });
    }
  }, [visible, monitoredCount]);

  if (!visible) return null;

  return (
    <Box
      sx={{
        backgroundColor: "common.lightShade",
        padding: "8px 16px 8px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 1,
        [theme.breakpoints.down("md")]: {
          display: "none",
        },
      }}
    >
      <Typography
        color="common.black"
        sx={{
          display: "flex",
          gap: 1,
          py: 0.25,
        }}
      >
        <SaleSvg
          style={{
            margin: "auto 0 auto 0",
          }}
        />
        <Typography
          sx={{
            fontWeight: 700,
            "@media (max-width: 960px)": {
              height: "auto",
            },
          }}
          color="common.black"
        >
          Monitoramento de {monitoredCount} {monitoredCount === 1 ? "processo" : "processos"} pausado — reative seu
          plano para voltar a receber movimentações (seu histórico continua disponível).
        </Typography>
      </Typography>
    </Box>
  );
};
